"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAppIntegrations = void 0;

var _ActionTypes = require("./ActionTypes");

var ecosystemClient = _interopRequireWildcard(require("../clients/ecosystemClient"));

var fetchAppIntegrations = function fetchAppIntegrations() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.APP_INTEGRATIONS_REQUESTED
    });
    return ecosystemClient.getAppIntegrations().then(function (payload) {
      dispatch({
        type: _ActionTypes.APP_INTEGRATIONS_RECEIVED,
        payload: payload
      });
    }, function (error) {
      dispatch({
        type: _ActionTypes.APP_INTEGRATIONS_FAILED,
        error: true,
        payload: error
      });
    });
  };
};

exports.fetchAppIntegrations = fetchAppIntegrations;


//////////////////
// WEBPACK FOOTER
// ./js/actions/GroupTagActions.js
// module id = 696
// module chunks = 209 210 211 212